import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-accent-500 font-medium mb-6">{contactData.subtitle}</p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-10">
            {contactData.desc}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">联系邮箱</div>
                <div className="text-sm font-medium text-foreground-800">contact@mitaovideo.com</div>
              </div>
            </div>
            <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">官方微信</div>
                <div className="text-sm font-medium text-foreground-800">密桃视频官方</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}